import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LogisticsOverview() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll();
  return <section id="logistics-overview" className="bg-background py-[160px] overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-0 items-center">
          {}
          <div ref={textRef} className={`lg:col-span-6 flex flex-col justify-center lg:pr-16 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <h1 className="font-sans font-bold text-5xl text-primary mb-6 tracking-tight">Efektivní logistika<br /></h1>
            <p className="font-sans text-[18px] leading-[1.6] text-muted-foreground mb-10 max-w-xl">Zajišťujeme rychlou a spolehlivou přepravu v celé Praze a okolí. Náš vozový park a optimalizované trasy garantují, že vaše čisté prádlo dorazí včas.</p>
            <div className="flex flex-wrap gap-4">
              <Button asChild className="rounded-[4px] bg-linear-to-r from-[var(--primary)] to-[#00A3C4] hover:opacity-90 hover:shadow-lg transition-all duration-300 border-0 text-white font-medium px-8 py-6 h-auto text-lg">
                <Link to="/LogisticsPage">
                  Naše služby
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-6 w-full h-full transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="relative w-full rounded-lg overflow-hidden shadow-2xl">
              <AspectRatio ratio={16 / 9} className="bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554604/img/delivery_vehicle_large.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554604/img/delivery_vehicle_large.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554604/img/delivery_vehicle_large.png-wvc-sizes" alt="Pradelna Vrsovice" className="object-cover w-full h-full" loading="lazy" />
                {}
                <div className="absolute inset-0 bg-blue-900/10 mix-blend-overlay pointer-events-none" />
              </AspectRatio>
            </div>
          </div>
        </div>
      </div>
    </section>;
}